// extracted by mini-css-extract-plugin
export var saItem = "saListIconsWithText-module--saItem--1Xo64";
export var saItemIcon = "saListIconsWithText-module--saItemIcon--iaKy-";
export var saItemTitle = "saListIconsWithText-module--saItemTitle--22vsx";
export var saItemText = "saListIconsWithText-module--saItemText--thkT3";
export var saBoxes3Blocks = "saListIconsWithText-module--saBoxes3Blocks--IOvfN";